"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

require("../styles/_assignment-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function itemMatchesFilter(item, filter) {
  return Object.values(item).some(function (itemField) {
    return itemField && typeof itemField === 'string' && itemField.toLowerCase().includes(filter.toLowerCase());
  });
}

var AssignmentList = /*#__PURE__*/function (_Component) {
  _inherits(AssignmentList, _Component);

  function AssignmentList(props) {
    var _this;

    _classCallCheck(this, AssignmentList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AssignmentList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onImageClick", (0, _lodash.default)(function (selectedItem, onImageClick) {
      return function () {
        onImageClick(selectedItem);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "applyFilter", (0, _memoizeOne.default)(function (filter, list) {
      return list.filter(function (item) {
        return itemMatchesFilter(item, filter);
      });
    }, function (_ref, _ref2) {
      var _ref3 = _slicedToArray(_ref, 2),
          newFilter = _ref3[0],
          newList = _ref3[1];

      var _ref4 = _slicedToArray(_ref2, 2),
          oldFilter = _ref4[0],
          oldList = _ref4[1];

      return newFilter !== oldFilter || newList !== oldList;
    }));

    _defineProperty(_assertThisInitialized(_this), "onAssignItem", (0, _lodash.default)(function (item) {
      return function () {
        var onAssignItem = _this.props.onAssignItem;
        onAssignItem(item);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleSetFilter", function (_ref5) {
      var value = _ref5.target.value;

      _this.setState({
        filter: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderItemBlock", function (item) {
      var _this$props = _this.props,
          assignedItem = _this$props.assignedItem,
          assignmentMatchField = _this$props.assignmentMatchField,
          getItemDisplayName = _this$props.getItemDisplayName,
          getItemDescription = _this$props.getItemDescription,
          assignBtnText = _this$props.assignBtnText,
          removeAssignmentBtnText = _this$props.removeAssignmentBtnText,
          defaultImage = _this$props.defaultImage,
          onImageClick = _this$props.onImageClick,
          hideAssignmentBtns = _this$props.hideAssignmentBtns,
          itemDefaultImageField = _this$props.itemDefaultImageField;
      var itemName = getItemDisplayName(item);
      var isAssigned = assignedItem && assignedItem[assignmentMatchField] === item[assignmentMatchField];
      return _react.default.createElement("div", {
        className: "assignment-list__list-item",
        key: "assignment-list-".concat(itemName)
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)('assignment-list__list-item__content', {
          'assignment-list__list-item__content--selected': isAssigned
        })
      }, _react.default.createElement(_uiKit.Image, {
        imageUrl: item.imageUrl,
        defaultImageIcon: itemDefaultImageField && item[itemDefaultImageField] || defaultImage,
        placeholderText: itemDefaultImageField && item[itemDefaultImageField] ? void 0 : itemName,
        width: "75px",
        height: "75px",
        onClick: onImageClick ? _this.onImageClick(item, onImageClick) : void 0,
        defaultIconBackground: isAssigned ? 'monkey' : void 0
      }), _react.default.createElement("div", {
        className: "assignment-list__list-item__content__desc"
      }, _react.default.createElement(_commonReact.Form.FormBlockDescription, {
        className: "assignment-list__form-block",
        isPrimaryButton: isAssigned,
        name: itemName,
        description: getItemDescription(item),
        onClickButton: _this.onAssignItem(item),
        buttonText: isAssigned ? removeAssignmentBtnText : assignBtnText,
        hideButton: hideAssignmentBtns,
        highlightedName: Boolean(isAssigned)
      }))));
    });

    _this.state = {
      filter: ''
    };
    return _this;
  }

  _createClass(AssignmentList, [{
    key: "render",
    value: function render() {
      var filter = this.state.filter;
      var _this$props2 = this.props,
          hideFilter = _this$props2.hideFilter,
          footerContent = _this$props2.footerContent,
          list = _this$props2.list,
          hideContent = _this$props2.hideContent;
      var filteredList = this.applyFilter(filter, list);
      return _react.default.createElement("div", {
        className: "assignment-list"
      }, !hideFilter ? _react.default.createElement("div", null, _react.default.createElement(_uiKit.Input, {
        className: "assignment-list__search",
        prefix: "search",
        placeholder: "Search",
        onChange: this.handleSetFilter
      })) : null, !hideContent ? _react.default.createElement("div", {
        className: "assignment-list__list-container"
      }, filteredList.map(this.renderItemBlock), !filteredList.length ? _react.default.createElement("p", null, "Nothing to show") : null) : null, footerContent || null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var hideFilter = props.hideFilter;

      if (hideFilter) {
        return _objectSpread({}, state, {
          filter: ''
        });
      }

      return state;
    }
  }]);

  return AssignmentList;
}(_react.Component);

exports.default = AssignmentList;

_defineProperty(AssignmentList, "defaultProps", {
  list: [],
  assignBtnText: 'Assign',
  removeAssignmentBtnText: 'Remove',
  defaultImage: 'user'
});